import { ColumnType } from '@getnuvo/importer-react'
import { ValidatorAPI } from '@getnuvo/importer-react'
import { NuvoImporterQuery } from 'generated/resources/graphql'

// Convert backend columnValues array to Nuvo ColumnValueAPI Record format
function convertColumnValuesToRecord(columnValues?: Array<{ column: string; values: string[] }>) {
  return (
    columnValues?.reduce<Record<string, string[]>>((acc, columnValue) => {
      if (columnValue.column && columnValue.values) {
        acc[columnValue.column] = columnValue.values
      }
      return acc
    }, {}) || undefined
  )
}

interface UseColumnCustomizationsProps {
  data?: NuvoImporterQuery
}

export type ColumnCustomization = {
  key: string
  label: string
  columnType: ColumnType
  hidden?: boolean
  disabled?: boolean
  validations?: ValidatorAPI[] | null
  customizations?: {
    type: 'transformation' | 'validation'
    computeWith: string
    parameters?:
      | {
          key: string
          value: string
        }[]
      | null
  }[]
}

export const useColumnCustomizations = ({ data }: UseColumnCustomizationsProps) => {
  const columns: ColumnCustomization[] =
    data?.universalImporter.schemaAdaptersConnection.nodes
      .filter(({ customizations }) => customizations && customizations.length > 0)
      .map(({ key, label, columnType, hidden, disabled, validations, customizations }) => ({
        key,
        label,
        columnType,
        hidden,
        disabled,
        validations:
          validations?.map(({ __typename: _, ...validation }) => ({
            ...validation,
            errorMessage: validation.errorMessage || '',
            columns: validation.columns || undefined,
            columnValues: convertColumnValuesToRecord(validation.columnValues || undefined),
          })) || null,
        customizations: customizations
          ?.map(({ __typename: _, ...customization }) => ({
            ...customization,
          }))
          .sort((a, b) => a.type.localeCompare(b.type)), // Sort by type (transformations first)
      })) || []

  // Sort columns by hidden (true first)
  columns.sort((a, b) => Number(b.hidden) - Number(a.hidden))

  return { columns }
}
